<template>
    <form @submit.prevent="updatePass" novalidate>
        <div
            v-if="errors.errorMessage()"
            v-html="errors.errorMessage()"
            class="form-error-message"
        ></div>
        <div
            v-if="successMessage"
            v-html="successMessage"
            class="form-success-message"
        ></div>

        <div class="form-group">
            <app-input
                :error="errors.get('password')"
                v-model="form.password"
                :type="passTypeFirst"
                icon="eye"
                :icon-clickable="true"
                @click="togglePasswordType"
                :label="$trans('auth.register.password_label')"
                :placeholder="$trans('auth.register.password_placeholder')"
            >
            </app-input>
        </div>

        <div class="form-group">
            <app-input
                :error="errors.get('password_confirmation')"
                v-model="form.password_confirmation"
                type="password"
                :label="$trans('auth.register.password_confirm_label')"
                :placeholder="
                    $trans('auth.register.password_confirm_placeholder')
                "
            >
            </app-input>
        </div>

        <div class="form-group flex-items submit-row">
            <div class="flex-item">
                <app-button
                    :loading="loading"
                    :disabled="successMessage !== false"
                    type="submit"
                    >{{ $trans("auth.reset.reset_pass") }}</app-button
                >
            </div>
        </div>

        <div class="separator"></div>

        <div class="form-group">
            <div
                class="agreement-text"
                v-html="$trans('auth.terms_text')"
            ></div>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            errors: this.$api.errors(),
            loading: false,
            successMessage: false,
            passTypeFirst: "password",
            form: {
                password: "",
                password_confirmation: "",
                email: window.app.reset.email,
                token: window.app.reset.token
            }
        };
    },
    methods: {
        togglePasswordType() {
            this.passTypeFirst =
                this.passTypeFirst == "password" ? "text" : "password";
        },
        async updatePass() {
            this.loading = true;

            this.errors.clear();
            const response = await this.$api.post(
                "auth/password-update",
                this.form
            );
            this.loading = false;

            if (response.hasErrors()) {
                this.errors = response.errors();
                return;
            }

            if (response.data().message) {
                this.successMessage = response.data().message;
            }

            if (response.data().redirect) {
                setTimeout(() => {
                    window.location.href = response.data().redirect;
                }, 2000);
            }
        }
    }
};
</script>
